export const ForgotPasswordFormFields = [
    {
        name: "email",
        type: "text",
        rules: [
            {
                required: true,
                message: "Please enter your email",
            },
            {
                pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid email address",
            },
        ],
        placeholder: "Enter your email",
    },
    {
        name: "submit",
        label: "Reset Password",
        type: "submit",
        htmlType: "submit",
        className: "btn-primary mt-4",
        buttonType: "primary",
        block: true,
    },
];
